import React from "react";
import NewHome from "./NewHome";

const Home = () => {
  return (
    <>
      {/* <DynamicSeoPage
        page="home"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <Suspense>
        <Banner />
      </Suspense>
      <Suspense>
        <Listings />
      </Suspense>
      <Suspense>
        <Gallery />
      </Suspense>
      <About />
      <Featured />
      <Testimonials /> */}
      <NewHome />
    </>
  );
};

export default Home;
